import { Pipe, PipeTransform } from '@angular/core';

const OBJECT_TYPES: Record<string, string> = {
  Order: $localize`Auftrag`,
  CarManagement: $localize`Fahrzeug`,
  User: $localize`Benutzer`,
  'Customers::LocationBufferstock': $localize`Bufferstock`,
  'Customers::LocationMachine': $localize`Maschinen-Standort`,
  'Customers::Location': $localize`Kunden-Standort`,
  'System::Timelog': $localize`Zeit`,
  'System::TimelogCorrection': $localize`Zeitkorrektur`,
  'CarManagement::Car': $localize`Fahrzeug`,
  Machine: $localize`Maschine`,
  'Reporting::DamageReport': $localize`Schadensmeldung`,
  'Warehouse::Order': $localize`Bufferstock-Bestellung`,
  'Warehouse::Basket': $localize`Basket`,
  'Warehouse::Bufferstock': $localize`Bufferstock`,
  'Warehouse::BufferstockCleanup': $localize`Bufferstock-Entsorgung`,
  'Warehouse::OrderAcceptance': $localize`Bufferstock-Bestellungsannahme`,
  'Warehouse::StockMovement': $localize`Bestandsbewegung`,
  'Warehouse::Inventur': $localize`Inventur`,
  'System::ObjectImage': $localize`Foto`,
};

@Pipe({ name: 'objectType' })
export class ObjectTypePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return OBJECT_TYPES[value] || value;
  }
}
